import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import AgentGreen from '../../characters/AgentGreen';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { CodeCrackingData } from '../../index';
import { t } from 'ttag';

const GoodbyeMessage: React.FC<ISlide<CodeCrackingData>> = ({ nextSlide, defaultHeader, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue = [
        {
            character: AgentGreen,
            text: t`Until next time Agent ${data.name}, there’s always space at Code Cracking HQ for you!`,
            buttonText: t`Thanks Agent!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default GoodbyeMessage;
